import styled from 'styled-components';
import LoadingSpinner from '../../../components/LoadingSpinner';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.special.shadow};
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
`;

const LoadingModal = () => {
  return (
    <Container>
      <LoadingSpinner />
    </Container>
  );
};

export default LoadingModal;
